module.exports = __webpack_public_path__ + "img/letter-spacing-02.08c9dd21.svg";